import {H3} from 'components/Typography';
import {ReactNode} from 'react';

import Field from '../Field';

const FieldDivider = ({children}: {children: ReactNode}) => (
    <Field type="divider">
        <H3 className="flex items-center gap-2">{children}</H3>
    </Field>
);
export default FieldDivider;
